/* eslint-disable no-template-curly-in-string */
/*
  This file is automagically generated; please do not make any changes.
  - To update, run `yarn generate-docs` from the ./lib directory.
  - To override, add a corresponding .js file in components-override.

  Please refer to the `new-components-guide.md` for full instructions!
*/

let generatedDocs = {
  muiName: "MuiIconButton",
  description:
    "Refer to the [Icons](/components/icons/) section of the documentation\r\nregarding the available icon options.",
  displayName: "IconButton",
  methods: [],
  props: {
    children: {
      type: {
        name: "custom",
        raw:
          "chainPropTypes(PropTypes.node, props => {\n  const found = React.Children.toArray(props.children).some(child => /*#__PURE__*/React.isValidElement(child) && child.props.onClick);\n\n  if (found) {\n    return new Error(['Material-UI: You are providing an onClick event listener ' + 'to a child of a button element.', 'Firefox will never trigger the event.', 'You should move the onClick listener to the parent button element.', 'https://github.com/mui-org/material-ui/issues/13957'].join('\\n'));\n  }\n\n  return null;\n})"
      },
      required: false,
      description: "The icon element."
    },
    classes: {
      type: { name: "object" },
      required: true,
      description:
        "Override or extend the styles applied to the component.\r\nSee [CSS API](#css) below for more details."
    },
    className: {
      type: { name: "string" },
      required: false,
      description: "@ignore"
    },
    color: {
      type: {
        name: "enum",
        value: [
          { value: "'default'", computed: false },
          { value: "'inherit'", computed: false },
          { value: "'primary'", computed: false },
          { value: "'secondary'", computed: false }
        ]
      },
      required: false,
      description:
        "The color of the component. It supports those theme colors that make sense for this component.",
      defaultValue: { value: "'default'", computed: false }
    },
    disabled: {
      type: { name: "bool" },
      required: false,
      description: "If `true`, the button will be disabled.",
      defaultValue: { value: "false", computed: false }
    },
    disableFocusRipple: {
      type: { name: "bool" },
      required: false,
      description: "If `true`, the  keyboard focus ripple will be disabled.",
      defaultValue: { value: "false", computed: false }
    },
    disableRipple: {
      type: { name: "bool" },
      required: false,
      description: "If `true`, the ripple effect will be disabled."
    },
    edge: {
      type: {
        name: "enum",
        value: [
          { value: "'start'", computed: false },
          { value: "'end'", computed: false },
          { value: "false", computed: false }
        ]
      },
      required: false,
      description:
        "If given, uses a negative margin to counteract the padding on one\r\nside (this is often helpful for aligning the left or right\r\nside of the icon with content above or below, without ruining the border\r\nsize and shape).",
      defaultValue: { value: "false", computed: false }
    },
    size: {
      type: {
        name: "enum",
        value: [
          { value: "'small'", computed: false },
          { value: "'medium'", computed: false }
        ]
      },
      required: false,
      description:
        "The size of the button.\r\n`small` is equivalent to the dense button styling.",
      defaultValue: { value: "'medium'", computed: false }
    }
  },
  styles: {
    root: { description: "Styles applied to the root element." },
    edgeStart: {
      description: 'Styles applied to the root element if `edge="start"`.'
    },
    edgeEnd: {
      description: 'Styles applied to the root element if `edge="end"`.'
    },
    colorInherit: {
      description: 'Styles applied to the root element if `color="inherit"`.'
    },
    colorPrimary: {
      description: 'Styles applied to the root element if `color="primary"`.'
    },
    colorSecondary: {
      description: 'Styles applied to the root element if `color="secondary"`.'
    },
    disabled: {
      description:
        "Pseudo-class applied to the root element if `disabled={true}`."
    },
    sizeSmall: {
      description: 'Styles applied to the root element if `size="small"`.'
    },
    label: { description: "Styles applied to the children container element." }
  }
};
export default generatedDocs;
